import React from "react";

const CardInfo = ({ topText, mainNumber, bottomText }) => {
  return (
    <div variant="borderless" className="roi--card-info-container">
      {topText && <span className="roi--card-info-top-text">{topText}</span>}
      <span className="roi--card-info-main-number">{mainNumber}</span>
      <span
        className={
          topText
            ? "roi--card-info-bottom-text"
            : "roi--card-info-bottom-text-no-top"
        }
      >
        {bottomText}
      </span>
    </div>
  );
};

export default CardInfo;
